import { ThemeName } from "@/styles/Theme";

const Icons = {
  Success: require("!svg-inline-loader!~assets/icons/success.svg"),
  Checkmark: require("!svg-inline-loader!~assets/icons/success.svg"),
  Fail: require("!svg-inline-loader!~assets/icons/fail.svg"),
  PageLeft: require("!svg-inline-loader!~assets/icons/paging_left.svg"),
  PageRight: require("!svg-inline-loader!~assets/icons/paging_right.svg"),
  Close: require("!svg-inline-loader!~assets/icons/close.svg"),
  CloseLite: require("!svg-inline-loader!~assets/icons/close_lite.svg"),
  ThumbsUp: require("!svg-inline-loader!~assets/icons/thumbs_up.svg"),
  ThumbsDown: require("!svg-inline-loader!~assets/icons/thumbs_down.svg"),
  Picker: require("!svg-inline-loader!~assets/icons/picker.svg"),
  Slider: require("!svg-inline-loader!~assets/icons/slider.svg"),
  Warning: require("!svg-inline-loader!~assets/icons/warning.svg"),
  Clock: require("!svg-inline-loader!~assets/icons/clockGeneric.svg"),
  BubbleCheckmark: require("!svg-inline-loader!~assets/icons/bubble_checkmark.svg"),
};

const bildIcons = {
  Success: require("!svg-inline-loader!~assets/icons/success_bild.svg"),
  Checkmark: require("!svg-inline-loader!~assets/icons/checkmark-bild.svg"),
  BubbleCheckmark: require("!svg-inline-loader!~assets/icons/bubble_checkmark-bild.svg"),
  Fail: require("!svg-inline-loader!~assets/icons/fail_bild.svg"),
  ThumbsUp: require("!svg-inline-loader!~assets/icons/thumbs_up_bild.svg"),
  ThumbsDown: require("!svg-inline-loader!~assets/icons/thumbs_down_bild.svg"),
  Slider: require("!svg-inline-loader!~assets/icons/slider_bild.svg"),
  Picker: require("!svg-inline-loader!~assets/icons/picker_bild.svg"),
  PageLeft: require("!svg-inline-loader!~assets/icons/paging_left_bild.svg"),
  PageRight: require("!svg-inline-loader!~assets/icons/paging_right_bild.svg"),
  Clock: require("!svg-inline-loader!~assets/icons/clockBild.svg"),
};

const weltIcons = {
  Success: require("!svg-inline-loader!~assets/icons/success_welt.svg"),
  Checkmark: require("!svg-inline-loader!~assets/icons/success_welt.svg"),
  Fail: require("!svg-inline-loader!~assets/icons/fail_bild.svg"),
  ThumbsUp: require("!svg-inline-loader!~assets/icons/thumbs_up_welt.svg"),
  ThumbsDown: require("!svg-inline-loader!~assets/icons/thumbs_down_welt.svg"),
  Slider: require("!svg-inline-loader!~assets/icons/slider_welt.svg"),
  Picker: require("!svg-inline-loader!~assets/icons/picker_welt.svg"),
  PageLeft: require("!svg-inline-loader!~assets/icons/paging_left_welt.svg"),
  PageRight: require("!svg-inline-loader!~assets/icons/paging_right_welt.svg"),
  Clock: require("!svg-inline-loader!~assets/icons/clockWelt.svg"),
  BubbleCheckmark: require("!svg-inline-loader!~assets/icons/bubble_checkmark-welt.svg"),
};

const cobiIcons = {
  Slider: require("!svg-inline-loader!~assets/icons/slider_cobi.svg"),
  Picker: require("!svg-inline-loader!~assets/icons/picker_cobi.svg"),
};

const bildBooksIcons = {
  Slider: require("!svg-inline-loader!~assets/icons/slider_bild_books.svg"),
};

const musikexpressIcons = {
  Picker: require("!svg-inline-loader!~assets/icons/picker_musikexpress.svg"),
  Slider: require("!svg-inline-loader!~assets/icons/slider_musikexpress.svg"),
};

const rollingstoneIcons = {
  Picker: require("!svg-inline-loader!~assets/icons/picker_rollingstone.svg"),
  Slider: require("!svg-inline-loader!~assets/icons/slider_rollingstone.svg"),
};

const metalhammerIcons = {
  Picker: require("!svg-inline-loader!~assets/icons/picker_metalhammer.svg"),
  Slider: require("!svg-inline-loader!~assets/icons/slider_metalhammer.svg"),
};

const brandIcons: Record<string, Partial<typeof Icons>> = {
  bild: bildIcons,
  bz: bildIcons,
  welt: weltIcons,
  welt_contrast: weltIcons,
  aubi: cobiIcons,
  cobi: cobiIcons,
  spobi: cobiIcons,
  bild_fitbook: bildBooksIcons,
  bild_stylebook: bildBooksIcons,
  bild_techbook: bildBooksIcons,
  bild_travelbook: bildBooksIcons,
  bild_myhomebook: bildBooksIcons,
  musikexpress: musikexpressIcons,
  rollingstone: rollingstoneIcons,
  metalhammer: metalhammerIcons,
};

export const getBrandIcons = (theme: ThemeName) => ({
  ...Icons,
  ...brandIcons[theme?.toLowerCase()],
});

export default Icons;
